import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "why-pdf-services-api"
    }}>{`Why PDF Services API?`}</h2>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className="align-left icon-xl-size horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/d6d113f40c8c91f8b838d909d7371089/create_secure_support.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "create-secure-and-convert-pdf-documents"
    }}>{`Create, secure, and convert PDF documents`}</h3>
    <p>{`Create a PDF from Microsoft Office documents, protect the content, and convert to other formats.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className="align-left icon-xl-size horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/e10ac37808b2109ec98e917ba4d50716/modify_pages.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "modify-pdfs-and-optimize-output"
    }}>{`Modify PDFs and optimize output`}</h3>
    <p>{`Programmatically alter a document, such as reordering, inserting, and rotating pages, as well as compressing the file.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className="align-left icon-xl-size link horizontal-align-heading linking" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/63ea37570003835842b55dd1bb48cdc4/cloud_services.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "leverage-adobes-cloud-based-services"
    }}>{`Leverage Adobe's cloud-based services`}</h3>
    <p>{`Access the same cloud-based APIs that power Adobe's end user applications to quickly deliver scalable, `}<a parentName="p" {...{
        "href": "https://www.adobe.com/content/dam/cc/en/security/pdfs/AdobeDocumentServices_SecurityOverview.pdf"
      }}>{`secure`}</a>{` solutions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      